import {inputFactory} from "core/Utils/Analytics/tagService";
import React, { useContext, useState } from "react";
import { store } from "store";
export const Select = ({
  label,
  type = "text",
  className = "",
  error,
  value,
  tabIndex,
  inputRef,
  name: propName = label,
  id: propId = propName,
  disableDefaultOption = false,
  ...props
}) => {
  const [inputValue, setInputValue] = useState(value);
  const errorClass = error ? " mdn-Input--attentionField" : "";
  const activeClass = props.children ? "mdn-Input--activatedField" : "";
  const finalExtraClasses = `${activeClass} ${errorClass} ${className}`.trim();
  const globalState = useContext(store);
  const { state } = globalState;
  const currentFlow = state.analytics.currentFlow;
  function handleChange(event, ...args) {
    setInputValue(event.target.value);
    inputFactory(label, currentFlow, event)
    props.onChange && props.onChange(event);
  }
  return (
    <div className={`mdn-Input ${finalExtraClasses}`}>
      <select
        tabIndex={tabIndex}
        name={propName}
        id={propId}
        className="mdn-Input-field"
        data-mdn-type="select"
        ref={inputRef}
        defaultValue={value}
        {...props}
        onChange={handleChange}
      >
        {!disableDefaultOption && <option value="">Selecione</option>}
        {props.children}
      </select>
      <label htmlFor={propId} className="mdn-Input-label">
        {label}
      </label>
      {error && <small className="mdn-Input-errorFeedback">{error}</small>}
    </div>
  );
};
